"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var StickyHeader_1 = __importDefault(require("./StickyHeader"));
var breakpoints_1 = require("../data/breakpoints");
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu() {
        var _this = _super.call(this, constants_1.DATA_NAVBAR) || this;
        if (!_this.getElement())
            return _this;
        _this.nav = _this.getElement().querySelector("[".concat(constants_1.DATA_NAVBAR_NAV, "]"));
        _this.submenus = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_SUBMENU, "]"));
        _this.submenuToggles = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_TOGGLE_SUBMENU, "]"));
        _this.submenuCloses = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_SUBMENU_CLOSE, "]"));
        _this.navLinks = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_NAV_LINK, "]"));
        _this.menuToggle = _this.getElement().querySelector("[".concat(constants_1.DATA_NAVBAR_TOGGLE, "]"));
        _this.menuCollapse = _this.getElement().querySelector("[".concat(constants_1.DATA_NAVBAR_COLLAPSE, "]"));
        _this.activeNavLink = _this.getActiveNavLink();
        // this.submenuLv3Placeholder = this.getElement().querySelector(`[${DATA_SUBMENU_LV3_PLACEHOLDER}]`);
        _this.submenuLv3Placeholders = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_SUBMENU_LV3_PLACEHOLDER, "]"));
        _this.submenuLinks = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_SUBMENU_LINK, "]"));
        _this.submenuLv3Toggles = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_TOGGLE_SUBMENU_LV3, "]"));
        _this.submenuLv3Closes = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_SUBMENU_LV3_CLOSE, "]"));
        _this.activeSubmenuLink = _this.getActiveSubmenuLink();
        _this.initEventListeners();
        return _this;
    }
    Menu.prototype.initEventListeners = function () {
        this.documentClick();
        this.toggleSubmenus();
        this.closeSubmenu();
        this.toggleMenu();
        this.toggleSubmenusLv3();
        this.closeSubmenuLv3();
    };
    Menu.prototype.documentClick = function () {
        var _this = this;
        document.addEventListener('click', function (event) {
            var _a, _b, _c;
            var composedPath = event.composedPath();
            var isOutsideClick = true;
            for (var i = 0; i < composedPath.length - 1; i++) {
                var currentEl = composedPath[i];
                if (currentEl === _this.getElement() || ((_a = currentEl === null || currentEl === void 0 ? void 0 : currentEl.dataset) === null || _a === void 0 ? void 0 : _a.submenu) !== undefined) {
                    isOutsideClick = false;
                    break;
                }
            }
            if (!isOutsideClick) {
                return;
            }
            _this.hideAllSubmenus();
            _this.hideAllSubmenusLv3();
            // add border to active nav-link
            (_b = _this.activeNavLink) === null || _b === void 0 ? void 0 : _b.classList.add(constantsClasses_1.CLASS_ACTIVE);
            (_c = _this.activeSubmenuLink) === null || _c === void 0 ? void 0 : _c.classList.add(constantsClasses_1.CLASS_ACTIVE);
            if (_this.nav.classList.contains(constantsClasses_1.CLASS_OPEN))
                _this.nav.classList.remove(constantsClasses_1.CLASS_OPEN);
            if (document.body.classList.contains(constantsClasses_1.CLASS_NAVBAR_OPEN))
                document.body.classList.remove(constantsClasses_1.CLASS_NAVBAR_OPEN);
        });
    };
    Menu.prototype.toggleMenu = function () {
        var _this = this;
        this.menuToggle.addEventListener('click', function () {
            Menu.isOpen = !Menu.isOpen;
            if (Menu.isOpen) {
                _this.showMenu();
                return;
            }
            _this.hideMenu();
        });
    };
    Menu.prototype.showMenu = function () {
        this.menuToggle.classList.remove(constantsClasses_1.CLASS_COLLAPSED);
        this.menuCollapse.classList.add(constantsClasses_1.CLASS_SHOW);
        StickyHeader_1.default.header.classList.add(constantsClasses_1.CLASS_OPEN, constantsClasses_1.CLASS_STICKY);
        document.body.classList.add(constantsClasses_1.CLASS_NAVBAR_OPEN);
    };
    Menu.prototype.hideMenu = function () {
        this.menuToggle.classList.add(constantsClasses_1.CLASS_COLLAPSED);
        this.menuCollapse.classList.remove(constantsClasses_1.CLASS_SHOW);
        StickyHeader_1.default.header.classList.remove(constantsClasses_1.CLASS_OPEN);
        StickyHeader_1.default.header.classList.add(constantsClasses_1.CLASS_CLOSING);
        if (window.scrollY < 1) {
            StickyHeader_1.default.header.classList.add(constantsClasses_1.CLASS_STICKY);
        }
        document.body.classList.remove(constantsClasses_1.CLASS_NAVBAR_OPEN);
    };
    /**
     * get current active nav-link
     * @private
     */
    Menu.prototype.getActiveNavLink = function () {
        var activeEl;
        for (var i = 0; i < this.navLinks.length; i++) {
            if (this.navLinks[i].classList.contains(constantsClasses_1.CLASS_ACTIVE)) {
                activeEl = this.navLinks[i];
                break;
            }
        }
        return activeEl ? activeEl : undefined;
    };
    Menu.prototype.getActiveSubmenuLink = function () {
        var activeEl;
        for (var i = 0; i < this.submenuLinks.length; i++) {
            if (this.submenuLinks[i].classList.contains(constantsClasses_1.CLASS_ACTIVE)) {
                activeEl = this.submenuLinks[i];
                break;
            }
        }
        return activeEl ? activeEl : undefined;
    };
    /**
     * closes submenu on outside click of navbar
     * @private
     */
    Menu.prototype.closeSubmenu = function () {
        var _this = this;
        var _a;
        (_a = this.submenuCloses) === null || _a === void 0 ? void 0 : _a.forEach(function (submenuClose) {
            submenuClose.addEventListener('click', function () {
                var id = submenuClose.dataset.submenuClose;
                var submenu = _this.menuCollapse.querySelector("[".concat(constants_1.DATA_SUBMENU, "=\"").concat(id, "\"]"));
                var submenuToggle = _this.menuCollapse.querySelector("[".concat(constants_1.DATA_TOGGLE_SUBMENU, "=\"").concat(id, "\"]"));
                submenuToggle === null || submenuToggle === void 0 ? void 0 : submenuToggle.setAttribute('aria-expanded', 'false');
                submenu === null || submenu === void 0 ? void 0 : submenu.classList.add(constantsClasses_1.CLASS_D_NONE);
                if (_this.nav.classList.contains(constantsClasses_1.CLASS_OPEN))
                    _this.nav.classList.remove(constantsClasses_1.CLASS_OPEN);
            });
        });
    };
    /**
     * hide all submenus and show respective submenu
     * @private
     */
    Menu.prototype.toggleSubmenus = function () {
        var _this = this;
        var _a;
        (_a = this.submenuToggles) === null || _a === void 0 ? void 0 : _a.forEach(function (toggle) {
            // get submenu for nav-link
            var submenu = toggle.parentElement.querySelector("[".concat(constants_1.DATA_SUBMENU, "]"));
            if (!submenu) {
                return;
            }
            toggle.addEventListener('click', function () {
                var _a, _b, _c;
                var submenuPlaceholder = toggle.parentElement.querySelector("[".concat(constants_1.DATA_SUBMENU_LV3_PLACEHOLDER, "]"));
                if (_this.nav.classList.contains(constantsClasses_1.CLASS_OPEN))
                    _this.nav.classList.remove(constantsClasses_1.CLASS_OPEN);
                if (document.body.classList.contains(constantsClasses_1.CLASS_NAVBAR_OPEN))
                    document.body.classList.remove(constantsClasses_1.CLASS_NAVBAR_OPEN);
                (_a = _this.submenuLinks) === null || _a === void 0 ? void 0 : _a.forEach(function (submenuLink) {
                    if (submenuLink.classList.contains(constantsClasses_1.CLASS_ACTIVE)) {
                        var submenuLv3 = submenuLink.nextElementSibling;
                        if (!submenuLv3 || !submenuPlaceholder)
                            return;
                        submenuPlaceholder.innerHTML = submenuLv3.innerHTML;
                    }
                });
                // if submenu already open on click
                // close open submenu, add border to current nav-link
                // do nothing afterward
                if (toggle.getAttribute('aria-expanded') === 'true') {
                    toggle.classList.remove(constantsClasses_1.CLASS_OPEN);
                    _this.hideAllSubmenus();
                    _this.hideAllSubmenusLv3();
                    (_b = _this.activeNavLink) === null || _b === void 0 ? void 0 : _b.classList.add(constantsClasses_1.CLASS_ACTIVE);
                    return;
                }
                _this.hideAllSubmenus();
                _this.hideAllSubmenusLv3();
                if (!_this.nav.classList.contains(constantsClasses_1.CLASS_OPEN))
                    _this.nav.classList.add(constantsClasses_1.CLASS_OPEN);
                if (!document.body.classList.contains(constantsClasses_1.CLASS_NAVBAR_OPEN))
                    document.body.classList.add(constantsClasses_1.CLASS_NAVBAR_OPEN);
                toggle.setAttribute('aria-expanded', 'true');
                // show submenu for clicked nav-link
                if (submenu.classList.contains(constantsClasses_1.CLASS_D_NONE)) {
                    submenu.classList.remove(constantsClasses_1.CLASS_D_NONE);
                }
                // if mobile do nothing
                if (window.innerWidth < breakpoints_1.GRID_BREAKPOINTS.xl) {
                    return;
                }
                // remove border from all nav-links
                (_c = _this.navLinks) === null || _c === void 0 ? void 0 : _c.forEach(function (navLink) {
                    if (navLink.classList.contains(constantsClasses_1.CLASS_ACTIVE)) {
                        navLink.classList.remove(constantsClasses_1.CLASS_ACTIVE);
                    }
                    if (navLink.classList.contains(constantsClasses_1.CLASS_OPEN)) {
                        navLink.classList.remove(constantsClasses_1.CLASS_OPEN);
                    }
                });
                // add border for clicked nav-link
                toggle.classList.add(constantsClasses_1.CLASS_OPEN);
            });
        });
    };
    /**
     * hide all submenus
     * @private
     */
    Menu.prototype.hideAllSubmenus = function () {
        var _a, _b, _c;
        (_a = this.submenuToggles) === null || _a === void 0 ? void 0 : _a.forEach(function (toggle) {
            if (toggle.classList.contains(constantsClasses_1.CLASS_OPEN)) {
                toggle.classList.remove(constantsClasses_1.CLASS_OPEN);
            }
        });
        (_b = this.navLinks) === null || _b === void 0 ? void 0 : _b.forEach(function (navLink) {
            navLink.setAttribute('aria-expanded', 'false');
        });
        (_c = this.submenus) === null || _c === void 0 ? void 0 : _c.forEach(function (submenu) {
            if (!submenu.classList.contains(constantsClasses_1.CLASS_D_NONE)) {
                submenu.classList.add(constantsClasses_1.CLASS_D_NONE);
            }
        });
    };
    Menu.prototype.toggleSubmenusLv3 = function () {
        var _this = this;
        var _a;
        (_a = this.submenuLv3Toggles) === null || _a === void 0 ? void 0 : _a.forEach(function (toggle) {
            // get submenu for nav-link
            var submenuLv3 = toggle.parentElement.querySelector("[".concat(constants_1.DATA_SUBMENU_LV3, "]"));
            if (!submenuLv3) {
                return;
            }
            toggle.addEventListener('click', function (e) {
                var _a, _b;
                // if submenu already open on click
                // close open submenu, add border to current nav-link
                // do nothing afterward
                if (toggle.getAttribute('aria-expanded') === 'true') {
                    toggle.classList.remove(constantsClasses_1.CLASS_OPEN);
                    _this.hideAllSubmenusLv3();
                    (_a = _this.activeSubmenuLink) === null || _a === void 0 ? void 0 : _a.classList.add(constantsClasses_1.CLASS_ACTIVE);
                    return;
                }
                _this.hideAllSubmenusLv3();
                toggle.setAttribute('aria-expanded', 'true');
                // show submenu for clicked nav-link
                if (submenuLv3.classList.contains(constantsClasses_1.CLASS_D_NONE)) {
                    submenuLv3.classList.remove(constantsClasses_1.CLASS_D_NONE);
                }
                // if mobile do nothing
                if (window.innerWidth < breakpoints_1.GRID_BREAKPOINTS.xl) {
                    return;
                }
                var cPath = e.composedPath();
                var submenuPlaceholder;
                for (var i = 0; i < cPath.length; i++) {
                    var el = cPath[i];
                    if (el.dataset && el.dataset.submenu) {
                        submenuPlaceholder = el.querySelector("[".concat(constants_1.DATA_SUBMENU_LV3_PLACEHOLDER, "]"));
                    }
                }
                if (submenuPlaceholder)
                    submenuPlaceholder.innerHTML = submenuLv3.innerHTML;
                // remove border from all nav-links
                (_b = _this.submenuLinks) === null || _b === void 0 ? void 0 : _b.forEach(function (link) {
                    if (link.classList.contains(constantsClasses_1.CLASS_ACTIVE)) {
                        link.classList.remove(constantsClasses_1.CLASS_ACTIVE);
                    }
                    if (link.classList.contains(constantsClasses_1.CLASS_OPEN)) {
                        link.classList.remove(constantsClasses_1.CLASS_OPEN);
                    }
                });
                // add border for clicked nav-link
                toggle.classList.add(constantsClasses_1.CLASS_OPEN);
            });
        });
    };
    Menu.prototype.closeSubmenuLv3 = function () {
        var _this = this;
        var _a;
        (_a = this.submenuLv3Closes) === null || _a === void 0 ? void 0 : _a.forEach(function (submenuLv3Close) {
            submenuLv3Close === null || submenuLv3Close === void 0 ? void 0 : submenuLv3Close.addEventListener('click', function () {
                var id = submenuLv3Close.dataset.submenuLv3Close;
                var submenu = _this.menuCollapse.querySelector("[".concat(constants_1.DATA_SUBMENU_LV3, "=\"").concat(id, "\"]"));
                var submenuToggle = _this.menuCollapse.querySelector("[".concat(constants_1.DATA_TOGGLE_SUBMENU_LV3, "=\"").concat(id, "\"]"));
                submenuToggle === null || submenuToggle === void 0 ? void 0 : submenuToggle.setAttribute('aria-expanded', 'false');
                submenu === null || submenu === void 0 ? void 0 : submenu.classList.add(constantsClasses_1.CLASS_D_NONE);
            });
        });
    };
    Menu.prototype.hideAllSubmenusLv3 = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        (_a = this.submenusLv3) === null || _a === void 0 ? void 0 : _a.forEach(function (submenuLv3) {
            submenuLv3.classList.add('d-none');
        });
        (_b = this.submenuLv3Placeholders) === null || _b === void 0 ? void 0 : _b.forEach(function (placeholder) {
            placeholder === null || placeholder === void 0 ? void 0 : placeholder.classList.add('d-none');
            placeholder.innerHTML = '';
        });
        (_c = this.submenuLinks) === null || _c === void 0 ? void 0 : _c.forEach(function (submenuLink) {
            submenuLink.setAttribute('aria-expanded', 'false');
            submenuLink.classList.remove(constantsClasses_1.CLASS_OPEN);
        });
        if (!this.activeSubmenuLink)
            return;
        this.activeSubmenuLink.classList.add(constantsClasses_1.CLASS_ACTIVE);
        var submenu = (_d = this.activeSubmenuLink.nextElementSibling) === null || _d === void 0 ? void 0 : _d.innerHTML;
        if (!submenu)
            return;
        var placeholder = (_h = (_g = (_f = (_e = this.activeSubmenuLink.parentElement) === null || _e === void 0 ? void 0 : _e.parentElement) === null || _f === void 0 ? void 0 : _f.parentElement) === null || _g === void 0 ? void 0 : _g.parentElement) === null || _h === void 0 ? void 0 : _h.querySelector("[".concat(constants_1.DATA_SUBMENU_LV3_PLACEHOLDER, "]"));
        placeholder.innerHTML = submenu;
    };
    Menu.isOpen = false;
    return Menu;
}(AbstractComponent_1.default));
exports.default = Menu;
